import { defineStore } from 'pinia';

import * as state from './nav.state';
import * as getters from './nav.getters';
import * as actions from './nav.actions';

export const useNavStore = defineStore('nav', () => ({
  ...state,
  ...getters,
  ...actions
}));
